var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-container"},[_c('iframe',{staticClass:"iframe-block",attrs:{"src":_vm.ruleLink}})])}
var staticRenderFns = []

export { render, staticRenderFns }